export default "__VITE_ASSET__CwfABwp4__"